module.exports = __webpack_public_path__ + "static/media/chrome-icon-144.18da459d.png";